import { defaultZodCatch } from '@/lib/converters/defaultZodCatch'
import { SortDirectionEnum, zSortDirectionEnum } from '@/schemas/sortDirectionEnumSchema'

import type { SortDirectionEnum as ResponseDto } from '@/gen/bff'
import type { SortDirectionEnumSchema } from '@/schemas/sortDirectionEnumSchema'

export const sortDirectionEnumConverter = (data?: ResponseDto): SortDirectionEnumSchema => {
  const response: SortDirectionEnumSchema = (() => {
    switch (data) {
      case 'ASC':
        return SortDirectionEnum.ASC
      case 'DESC':
        return SortDirectionEnum.DESC
      default:
        return SortDirectionEnum.ASC
    }
  })()

  return zSortDirectionEnum.catch(defaultZodCatch).parse(response)
}
